export const setState = (state) => {
  return {
    type: "SET_BADGING_STATE",
    payload: state,
  };
};

export default { setState };
